import * as Yup from 'yup'

import { ScheduledCommunicationStatus } from '@/types/ScheduledCommunication'

export const initialValues: EditScheduledCommunicationFormValuesType = {
  content: '',
  status: undefined,
  cancelledReason: '',
  scheduledDatetime: '',
}

export interface EditScheduledCommunicationFormValuesType {
  cancelledReason?: string
  content: string
  scheduledDatetime: string | Date
  status?: ScheduledCommunicationStatus
}

export const formSchema = Yup.object({
  cancelledReason: Yup.string().when('status', {
    is: (status) => status === ScheduledCommunicationStatus.Cancelled,
    then: () => Yup.string().required('Cancelled reason is required when cancelling a Scheduled Communication.'),
    otherwise: () => Yup.string(),
  }),
  content: Yup.string().required('Scheduled Communication content is required.'),
})
